import { QueryStatus } from "@reduxjs/toolkit/query";
import { useAppSelector } from "store";

const useLoading = (type: "queries" | "mutations" = "queries") => {
	const isLoading = useAppSelector((state) => {
		if (type === "queries") {
			return Object.values(state.api.queries).some((query) => {
				return query && query.status === QueryStatus.pending;
			});
		}

		return Object.values(state.api.mutations).some((query) => {
			return query && query.status === QueryStatus.pending;
		});
	});
	return { isLoading };
};

export default useLoading;
